const accountprint = resolve => require(['@/pages/settleAccounts/shopset/accountprint/index.vue'], resolve);
const shopsetinfo = resolve => require(['@/pages/settleAccounts/shopset/shopsetinfo/index.vue'], resolve);
const shopset = resolve => require(['@/pages/settleAccounts/shopset/index.vue'], resolve);
const storeSettlement = resolve => require(['@/pages/settleAccounts/storeSettlement/index.vue'], resolve);
const storeSettlementPrint = resolve => require(['@/pages/settleAccounts/storeSettlement/storeSettlementPrint/index.vue'], resolve);
const storeSettlementDetails = resolve => require(['@/pages/settleAccounts/storeSettlement/storeSettlementDetails/index.vue'], resolve);
const storeprint = resolve => require(['@/pages/settleAccounts/shopset/storeprint/index.vue'], resolve);

export default [
  /********************结算管理******************/
  {
    path: "/shopset",
    name: "店铺销售结算",
    component: shopset
  },
  {
    path: "/storeSettlement",
    name: "店铺货款结算",
    component: storeSettlement
  },
  {
    path: "/storeSettlement/storeSettlementPrint",
    name: "店铺货款结算打印单",
    component: storeSettlementPrint
  },
  {
    path: "/storeSettlement/storeSettlementDetails",
    name: "店铺货款结算查看",
    component: storeSettlementDetails
  },
  {
    path: "/shopset/shopsetinfo",
    name: "店铺销售结算详情",
    component: shopsetinfo
  },
  {
    path: "/shopset/accountprint",
    name: "运营端对账单打印",
    component: accountprint
  },
  {
    path: "/shopset/storeprint",
    name: "商家端对账单打印",
    component: storeprint
  },
  {
    path: "/cardsReport",
    name: "美礼卡相关报表"
  }
]
